import DcPage from '@/components/landing/dcv2/DcPage';
import { ForumProvider } from '@/features/forum/ForumContext';
import { ThreadDetail } from '@/features/forum/components/ThreadDetail';

export default function ForumPost() {
  return (
    <ForumProvider>
      <DcPage>
        <ThreadDetail />
      </DcPage>
    </ForumProvider>
  );
}
